import Button from '@material-ui/core/Button';
import {withStyles} from '@material-ui/core/styles';
import { orange } from '@material-ui/core/colors';

const ColorButton = withStyles((theme: Theme) => ({
  root: {
    color: 'white',
    backgroundColor: '#8AD1CA',
    '&:hover': {
      backgroundColor: '#008577',
    },
  },
}))(Button);

export {ColorButton};
